import { createActions } from 'redux-actions';

const {
  dadataSearchBank,
  dadataSearchBankSuccess,
  dadataSearchBankFailure,
  dadataSetBank,
  dadataIdleBank,
} = createActions(
  'DADATA_SEARCH_BANK',
  'DADATA_SEARCH_BANK_SUCCESS',
  'DADATA_SEARCH_BANK_FAILURE',
  'DADATA_SET_BANK',
  'DADATA_IDLE_BANK'
);

export {
  dadataSearchBank,
  dadataSearchBankSuccess,
  dadataSearchBankFailure,
  dadataSetBank,
  dadataIdleBank,
};
